export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_08.f21a3007.JPG";